export default __webpack_public_path__ + "static/media/project_banner_soulsearch.f51454b3.png";